import React from "react";

var _languageObj = {};
var service = {
    getTranslate : function(key, isHTML){
        const placeholder = " ";
    	if(isHTML){
        	return <span dangerouslySetInnerHTML={{__html: _languageObj[key] || placeholder}}></span>
    	}
        return _languageObj[key] || placeholder;
    },
    setTranslate: function(obj){
        _languageObj = obj;
    }
}

module.exports = {
    getTranslate : service.getTranslate,
    setTranslate : service.setTranslate
}


// WEBPACK FOOTER //
// ./src/service/localeService.js